module.exports = __webpack_public_path__ + "static/media/image_card.bd01ed40.png";